(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/divided-code-input.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/divided-code-input.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState,
  Fragment
} = React;
const {
  Form
} = svs.ui.reactForm;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  constants,
  validateProductId,
  validateTicketId
} = svs.ticketsValidateManual.utils;
const {
  CODE_PART_LENGTHS,
  ERRORS
} = constants;
const {
  REQUIRED_ERROR,
  MESSAGE_MIN,
  INVALID_PRODUCT_ID
} = ERRORS;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const TWO_MINUTES = 2;
const validateEachCodePart = codeParts => codeParts.map((part, index) => {
  if (part.length < CODE_PART_LENGTHS[index]) {
    return MESSAGE_MIN;
  } else if (index === 0 && !validateProductId(part).isValid) {
    return INVALID_PRODUCT_ID;
  }
  return undefined;
}).reduce((error, partError, index) => _objectSpread(_objectSpread({}, error), {}, {
  ["code-part-".concat(index)]: partError
}), {});
setGlobal('svs.ticketsValidateManual.pages.home.components.DividedCodeInput', _ref => {
  let {
    ticketId = null
  } = _ref;
  const [state, setState, clearState] = svs.ticketsValidateManual.hooks.useLocalStorage('codeParts', 'tickets-validate-manual', {
    codeParts: CODE_PART_LENGTHS.map(() => '')
  }, TWO_MINUTES);
  const [error, setError] = useState(null);
  const codeValidation = validateTicketId(state.codeParts.join('-'));
  useEffect(() => {
    const ticketIdParam = ticketId === null || ticketId === void 0 ? void 0 : ticketId.split('-'); 
    if ((ticketIdParam === null || ticketIdParam === void 0 ? void 0 : ticketIdParam.length) === 1) {
      const ticketIdString = ticketIdParam[0];
      for (let i = 0, startIndex = 0; i < CODE_PART_LENGTHS.length; i++) {
        ticketIdParam[i] = ticketIdString.slice(startIndex, startIndex + CODE_PART_LENGTHS[i]);
        startIndex += CODE_PART_LENGTHS[i];
      }
    }
    if (state.codeParts.join('').length === 0) {
      if ((ticketIdParam === null || ticketIdParam === void 0 ? void 0 : ticketIdParam.join('').length) > 0) {
        setState({
          codeParts: CODE_PART_LENGTHS.map((length, i) => {
            var _ticketIdParam$i$slic, _ticketIdParam$i;
            return (_ticketIdParam$i$slic = (_ticketIdParam$i = ticketIdParam[i]) === null || _ticketIdParam$i === void 0 ? void 0 : _ticketIdParam$i.slice(0, length)) !== null && _ticketIdParam$i$slic !== void 0 ? _ticketIdParam$i$slic : '';
          })
        });
        const errors = validateEachCodePart(ticketIdParam);
        if (Object.values(errors).some(error => error)) {
          setError(_objectSpread(_objectSpread({}, errors), {}, {
            code: validateTicketId(ticketIdParam.join('-')).errorMessage
          }));
          svs.ticketsValidateManual.logger.warn("Invalid ticketIdParam: ".concat(Object.values(errors).filter(error => error).join(', ')), ticketIdParam);
        }
      }
    } else {
      const errors = validateEachCodePart(state.codeParts);
      if (Object.values(errors).some(error => error)) {
        setError(_objectSpread(_objectSpread({}, errors), {}, {
          code: codeValidation.errorMessage
        }));
      }
    }
  }, []);
  const errorMessageFromFormData = formData => Object.entries(formData).reduce((error, _ref2) => {
    let [key, value] = _ref2;
    return value.isValid ? error : _objectSpread(_objectSpread({}, error), {}, {
      [key]: value.errorMessage
    });
  }, {});

  const onBlur = e => {
    if (!e.relatedTarget && !codeValidation.isValid) {
      setError(_objectSpread(_objectSpread({}, validateEachCodePart(state.codeParts)), {}, {
        code: codeValidation.errorMessage
      }));
    }
  };
  const onChange = _ref3 => {
    let {
      target
    } = _ref3;
    error && setError(null); 

    const codePartIndex = Number(target.name.split('-').slice(-1)[0]);
    let nextIndex = codePartIndex + 1;
    const oldValue = state.codeParts[codePartIndex];
    const newValue = target.value.replace(/[^0-9]/g, '').slice(0, CODE_PART_LENGTHS[codePartIndex]);
    let rest = target.value.replace(/[^0-9]/g, '').slice(newValue.length);
    const newCodeParts = [...state.codeParts.slice(0, codePartIndex),
    target.value.length === target.selectionStart || !rest.length ? newValue : oldValue, ...state.codeParts.slice(codePartIndex + 1)];
    const shouldFocusNext = () => document.activeElement === target && newValue.length === CODE_PART_LENGTHS[codePartIndex];

    if (target.value.length === target.selectionStart) {
      while ((rest.length || shouldFocusNext()) && nextIndex < CODE_PART_LENGTHS.length) {
        const nextValue = rest.slice(0, CODE_PART_LENGTHS[nextIndex]);
        rest = rest.slice(nextValue.length);
        if (state.codeParts[nextIndex].length === 0 || nextValue.length >= newCodeParts[nextIndex].length) {
          newCodeParts[nextIndex] = nextValue;
        }
        const nextInput = target.form.elements["code-part-".concat(nextIndex)];
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
        nextIndex++;
      }
    } else {
      const cursorPosition = target.selectionStart - rest.length;
      requestAnimationFrame(() => {
        target.setSelectionRange(cursorPosition, cursorPosition);
      });
    }
    setState({
      codeParts: newCodeParts
    });
  };

  const onKeyDown = event => {
    const codePartIndex = Number(event.target.name.split('-').slice(-1)[0]);
    if (event.key === 'Backspace' && event.target.selectionStart === 0 && event.target.selectionEnd === 0) {
      const prevIndex = codePartIndex - 1;
      if (prevIndex >= 0) {
        event.preventDefault();
        const prevInput = event.target.form.elements["code-part-".concat(prevIndex)];
        prevInput.focus();
        prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
      }
    } else if (event.key === 'ArrowLeft' && event.target.selectionStart === 0) {
      const prevIndex = codePartIndex - 1;
      if (prevIndex >= 0) {
        event.preventDefault();
        const prevInput = event.target.form.elements["code-part-".concat(prevIndex)];
        prevInput.focus();
        prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
      }
    } else if (event.key === 'ArrowRight' && event.target.selectionStart === event.target.value.length) {
      const nextIndex = codePartIndex + 1;
      if (nextIndex < CODE_PART_LENGTHS.length) {
        event.preventDefault();
        const nextInput = event.target.form.elements["code-part-".concat(nextIndex)];
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
      }
    }
  };
  const onSubmit = async (e, formData) => {
    var _svs$core$urlMapping$;
    error && setError(null); 
    e.preventDefault();
    const codeValidation = validateTicketId(state.codeParts.join('-'));
    if (!codeValidation.isValid) {
      svs.ticketsValidateManual.logger.info('ticketId manual (divided) input fail');
      setError(_objectSpread(_objectSpread({}, errorMessageFromFormData(formData)), {}, {
        code: codeValidation.errorMessage
      }));
      return;
    }
    svs.ui.loader.show(); 
    svs.ticketsValidateManual.logger.info('ticketId manual (divided) input success');
    const {
      branding,
      shortName
    } = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(state.codeParts.join('-'));
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateManualValidation(shortName);
    const validatePath = (_svs$core$urlMapping$ = svs.core.urlMapping.get('ticketValidated')) === null || _svs$core$urlMapping$ === void 0 ? void 0 : _svs$core$urlMapping$.replace(':branding', branding).replace(':ticketId', state.codeParts.join('-')).replace('/:code', '');
    const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    const extraParams = {
      validateticketonline: true,
      branding
    };
    if (isLoggedIn) {
      var _svs, _svs$setupExtraData;
      await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
        extraData: extraParams
      }));
      svs.utils.url.navigate(validatePath);
    } else {
      svs.components.customer_login.login({
        returnNewCustomer: true,
        returnUrl: validatePath,
        extraParams
      });
    }
    clearState();
  };
  return React.createElement(GridRow, {
    className: "u-flex-justify-content-center margin-bottom-2"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 6,
    sm: 12
  }, React.createElement(Form, {
    className: "code-input-form margin-center",
    onSubmit: onSubmit,
    setError: error
  }, React.createElement("div", {
    className: "code-input-layout margin-bottom-1-half"
  },
  CODE_PART_LENGTHS.map((codePartLength, index) => {
    var _state$codeParts$inde;
    return React.createElement(Fragment, {
      key: index
    }, React.createElement(TextInput, {
      autoComplete: "off",
      className: "code-input u-inline-block input-length-".concat(codePartLength),
      "data-testid": "code-part-".concat(index),
      errorMessageRequired: REQUIRED_ERROR,
      helpMessage: "".concat(state.codeParts[index].length, "/").concat(codePartLength),
      inputMode: "numeric",
      label: state.codeParts[index].length ? "".concat(state.codeParts[index].length, "/").concat(codePartLength) : Array.from({
        length: codePartLength
      }, () => '•').join(' '),
      min: codePartLength,
      name: "code-part-".concat(index),
      onBlur: onBlur,
      onChange: onChange,
      onKeyDown: onKeyDown,
      validateFn: index === 0 ? validateProductId : null,
      value: (_state$codeParts$inde = state.codeParts[index]) !== null && _state$codeParts$inde !== void 0 ? _state$codeParts$inde : ''
    }), index + 1 < CODE_PART_LENGTHS.length ? React.createElement("span", {
      className: "f-800 f-normal code-hyphen"
    }, "-") : null, index === 2 ? React.createElement("br", null) : null);
  }), (error === null || error === void 0 ? void 0 : error.code) && React.createElement("div", {
    className: "u-flex u-flex-align-items-center margin-top-half"
  }, React.createElement(Icon, {
    className: "margin-left-1 margin-right-half",
    color: "fc-red",
    icon: "exclamation-sign",
    size: 200
  }), React.createElement("div", {
    className: "code-input-error-message f-200 padding-0 margin-bottom-0",
    "data-testid": "code-input-error"
  }, error === null || error === void 0 ? void 0 : error.code))), React.createElement(Button, {
    block: true,
    disabled: !codeValidation.isValid,
    focus: true,
    type: "submit"
  }, "Forts\xE4tt"))));
});

 })(window);